import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { FeatureFlags } from '../../feature-flags/feature-flags';
import { LocalStorageService } from '../../services/local-storage-service';
import Global from '../../store/global-selectors';
import { RECOMMENDATION_REGISTRY } from './seller-recommendation-registry';

export const useShouldShowSellerRecommendation = (recommendationType: string): boolean => {
  const { pathname } = useLocation();
  const entry = RECOMMENDATION_REGISTRY[recommendationType];

  const recommendation = useSelector((state) => Global.selectSellerRecommendationsRecommendationByType(state, { recommendationType }));
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  const isFeatureFlagEnabled = useSelector((state: any) => {
    const ff = new FeatureFlags({ featureFlags: state.featureFlags });
    return entry?.featureFlag ? ff.getFeatureFlag(entry.featureFlag) : true;
  });

  if (!entry || !recommendation) return false;
  if (!isFeatureFlagEnabled) return false;
  if (recommendation.isActioned) return false;
  if (recommendation.dismissedCount >= entry.maxDismissalCount) return false;

  const isOnAllowedRoute =
    !entry.allowedRoutes?.length || entry.allowedRoutes.some((route) => pathname === route || pathname.startsWith(`${route}/`));
  if (!isOnAllowedRoute) return false;

  const { dismissalStorageKey } = entry;
  const isSessionDismissed = !!(dismissalStorageKey && LocalStorageService.getItem(dismissalStorageKey));
  if (isSessionDismissed) return false;

  return true;
};
